/* Cash Money 6.13 — كروت الخزن بتقلب لوحدها بين صور الخزنة (مقفولة/مفتوحة) زي إعلانات الكتالوج */
(function(){
  if (window.cmAnim) return; window.cmAnim = 1;
  try { if (matchMedia('(prefers-reduced-motion: reduce)').matches) return; } catch(e){}
  var me = document.currentScript, mapUrl = me && me.getAttribute('data-map');
  if (!mapUrl) return;
  var MAP = null, done = new WeakSet(), cards = new Map(), io = null;
  var HOLD = 2000;
  function handleOf(a){
    var m = (a.getAttribute('href') || '').match(/\/products\/([^?#\/]+)/);
    if (!m) return null;
    try { return decodeURIComponent(m[1]).toLowerCase(); } catch(e){ return m[1].toLowerCase(); }
  }
  function build(a, list){
    var img = a.querySelector('img'); if (!img) return null;
    var box = img.parentElement;
    if (getComputedStyle(box).position === 'static') box.style.position = 'relative';
    var fit = getComputedStyle(img).objectFit || 'contain';
    var w = Math.max(300, Math.min(800, Math.ceil((img.clientWidth || 300) * (window.devicePixelRatio || 1) / 100) * 100));
    var layers = list.map(function(n){
      var i = new Image(); i.decoding = 'async'; i.alt = ''; i.setAttribute('aria-hidden','true');
      i.className = 'cm-anim-layer';
      i.style.cssText = 'position:absolute;inset:0;width:100%;height:100%;object-fit:' + fit + ';opacity:0;transition:opacity .6s ease;pointer-events:none;background:#fff;z-index:1';
      i.src = '/cdn/shop/files/' + encodeURIComponent(n) + '?width=' + w;
      box.appendChild(i); return i;
    });
    var st = { layers: layers, k: -1, t: null };
    st.step = function(){
      var n = st.layers.length, nx = (st.k + 1) % n, L = st.layers[nx];
      if (!L.complete || !L.naturalWidth) return;
      L.style.opacity = 1;
      if (st.k >= 0 && st.k !== nx) st.layers[st.k].style.opacity = 0;
      st.k = nx;
    };
    return st;
  }
  function onVis(entries){
    entries.forEach(function(e){
      var a = e.target.__cmA || e.target, st = cards.get(a);
      if (e.isIntersecting) {
        if (!st) { var h = handleOf(a); st = build(a, MAP[h]); if (!st) return; cards.set(a, st); }
        if (!st.t) st.t = setInterval(st.step, HOLD);
      } else if (st && st.t) { clearInterval(st.t); st.t = null; }
    });
  }
  function scan(root){
    if (!MAP) return;
    (root || document).querySelectorAll('a[href*="/products/"]').forEach(function(a){
      if (done.has(a)) return;
      var h = handleOf(a); if (!h || !MAP[h]) return;
      var img = a.querySelector('img'); if (!img) return;
      if (a.closest('header, .header, predictive-search-component, .predictive-search, .rsi-form-main')) return;
      done.add(a); img.__cmA = a; io.observe(img); /* مش الـ a: الكروت فيها a.contents (display:contents) ملهاش مساحة */
    });
  }
  function start(){
    fetch(mapUrl).then(function(r){ return r.json(); }).then(function(m){
      MAP = {}; Object.keys(m).forEach(function(k){ MAP[k.toLowerCase()] = m[k]; });
      io = new IntersectionObserver(onVis, { threshold: 0.5 });
      scan();
      var q = null;
      new MutationObserver(function(){ if (q) return; q = setTimeout(function(){ q = null; scan(); }, 500); })
        .observe(document.body, { childList: true, subtree: true });
    }).catch(function(){});
  }
  if ('IntersectionObserver' in window) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  }
})();
